<template>
  <div>

     <v-footer
      color="grey darken-4"
      app
      absolute
      class="top-bor-pink"
      padless
    >

      <v-container fluid class="black" py-0>

        <v-container class="max-container mx-auto " py-0>
          <v-layout row wrap>
            <v-flex xs12 pa-3>
              <v-layout row wrap align-content-center fill-height class="">
                <v-container fluid>
                  <v-layout row wrap justify-end px-4>
                    <span class="d-block" >© 2020 Shifft BV</span>
                  </v-layout>
                </v-container>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>

      </v-container>

    </v-footer>

  </div>
</template>

<script>
export default {

  data: () => ({
    footitems1: [
      {
        text: 'Dashboard',
        url: '/overons',
      },
      {
        text: 'Aansluitingen overzicht',
        url: '/producten',
      },
      {
        text: 'Storingen',
        url: '/maatwerk',
      },
      {
        text: 'Onderhoud',
        url: '/cases',
      },
    ],
    footitems2: [
      {
        text: 'Bedrijfsbeheer',
        url: '/contact',
      },
      {
        text: 'Uitloggen',
        url: '/vacatures',
      },
    ],
  }),

  methods: {
  },

};
</script>


<style scoped>


</style>
